import React, { useEffect, useRef, useState } from "react";
import classes from "./WhatsIncludedMobile.module.css";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { Input } from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { useHistory } from "react-router-dom";
import {
  cancelIcon,
  EquipmentIcon,
  ApparelIcon,
  AccessoriesIcon,
  AddIconBlue,
} from "../../../../../constant/imagePath";
import { CommonQuestions } from "../../../../../stories/CommonQuestions/CommonQuestions";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import { Sleep } from "../../../../../util/CustomFunctions";
import accordionCss from "../../../../../stories/CommonQuestions/commonQuestions.module.css";
import AddEquipmentModal from "../../../../../components/Modals/CoachFlow/OnBoarding/AddEquipment/AddEquipment";
import { setActiveTab } from "../../../../../store/Actions/commonAction";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../../store/Actions/authAction";

const WhatsIncludedMobile = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state?.commonReducer?.activeTab);
  const getDataFromRedux = useSelector(
    (state) => state?.onBoardingReducer?.setLesson
  );

  const [showEquipmentModal, setShowEquipmentModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [sectionTitle, setSectionTitle] = useState("");
  const [modalData, setModalData] = useState([]);

  //

  //  Provide states
  const [renderEquipments, setRenderEquipments] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderEquipments
      : [
          { label: "Grips", value: "Grips", isChecked: "" },
          { label: "Racquet string", value: "Racquet string", isChecked: "" },
          { label: "Tennis racquet", value: "Tennis racquet", isChecked: "" },
          { label: "Tennis Balls", value: "Tennis Balls", isChecked: "" },
        ]
  );
  const [renderApparels, setRenderApparels] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderApparels
      : [
          { label: "Tennis shoes", value: "Tennis shoes", isChecked: "" },
          { label: "Sweatbands", value: "Sweatbands", isChecked: "" },
          { label: "Practice skirt", value: "Practice skirt", isChecked: "" },
          { label: "Racquet bag", value: "Racquet bag", isChecked: "" },
          { label: "Practice shirts", value: "Practice shirts", isChecked: "" },
          { label: "Hat/Visor", value: "Hat/Visor", isChecked: "" },
        ]
  );
  const [renderAccessories, setRenderAccessories] = useState(
    getDataFromRedux?.provide
      ? getDataFromRedux?.provide?.renderAccessories
      : [
          { label: "Water", value: "Water", isChecked: "" },
          { label: "Sunglasses", value: "Sunglasses", isChecked: "" },
          {
            label: "Hair ties/Headband",
            value: "Hair ties/Headband",
            isChecked: "",
          },
          { label: "Athletic tape", value: "Athletic tape", isChecked: "" },
          { label: "Sunscreen", value: "Sunscreen", isChecked: "" },
        ]
  );
  //  Bring states
  const [renderEquipmentsForBring, setRenderEquipmentsForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderEquipmentsForBring
      : [
          { label: "Grips", value: "Grips", isChecked: "" },
          { label: "Racquet string", value: "Racquet string", isChecked: "" },
          { label: "Tennis racquet", value: "Tennis racquet", isChecked: "" },
          { label: "Tennis Balls", value: "Tennis Balls", isChecked: "" },
        ]
  );
  const [renderApparelsForBring, setRenderApparelsForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderApparelsForBring
      : [
          { label: "Tennis shoes", value: "Tennis shoes", isChecked: "" },
          { label: "Sweatbands", value: "Sweatbands", isChecked: "" },
          { label: "Practice skirt", value: "Practice skirt", isChecked: "" },
          { label: "Racquet bag", value: "Racquet bag", isChecked: "" },
          { label: "Practice shirts", value: "Practice shirts", isChecked: "" },
          { label: "Hat/Visor", value: "Hat/Visor", isChecked: "" },
        ]
  );
  const [renderAccessoriesForBring, setRenderAccessoriesForBring] = useState(
    getDataFromRedux?.bring
      ? getDataFromRedux?.bring?.renderAccessoriesForBring
      : [
          { label: "Water", value: "Water", isChecked: "" },
          { label: "Sunglasses", value: "Sunglasses", isChecked: "" },
          {
            label: "Hair ties/Headband",
            value: "Hair ties/Headband",
            isChecked: "",
          },
          { label: "Athletic tape", value: "Athletic tape", isChecked: "" },
          { label: "Sunscreen", value: "Sunscreen", isChecked: "" },
        ]
  );

  //
  function onAdd() {
    if (sectionTitle === "what will you provide?") {
      if ("Equipment" === modalTitle) {
        const newArr = [...modalData];
        setRenderEquipments(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...modalData];
        setRenderApparels(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...modalData];
        setRenderAccessories(newArr);
      }
    } else {
      if ("Equipment" === modalTitle) {
        const newArr = [...modalData];
        setRenderEquipmentsForBring(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...modalData];
        setRenderApparelsForBring(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...modalData];
        setRenderAccessoriesForBring(newArr);
      }
    }
  }

  useEffect(() => {
    if (sectionTitle === "what will you provide?") {
      if ("Equipment" === modalTitle) {
        const newArr = [...renderEquipments];
        setModalData(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...renderApparels];
        setModalData(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...renderAccessories];
        setModalData(newArr);
      }
    } else {
      if ("Equipment" === modalTitle) {
        const newArr = [...renderEquipmentsForBring];
        setModalData(newArr);
      }
      if ("Apparel" === modalTitle) {
        const newArr = [...renderApparelsForBring];
        setModalData(newArr);
      }
      if ("Accessories" === modalTitle) {
        const newArr = [...renderAccessoriesForBring];
        setModalData(newArr);
      }
    }
  }, [showEquipmentModal]);

  //
  const willProvide = [
    {
      title: "Equipment",
      state: renderEquipments,
      setter: setRenderEquipments,
    },
    { title: "Apparel", state: renderApparels, setter: setRenderApparels },
    {
      title: "Accessories",
      state: renderAccessories,
      setter: setRenderAccessories,
    },
  ];
  const shouldBring = [
    {
      title: "Equipment",
      state: renderEquipmentsForBring,
      setter: setRenderEquipmentsForBring,
    },
    {
      title: "Apparel",
      state: renderApparelsForBring,
      setter: setRenderApparelsForBring,
    },
    {
      title: "Accessories",
      state: renderAccessoriesForBring,
      setter: setRenderAccessoriesForBring,
    },
  ];
  function saveDataIntoRedux() {
    dispatch(
      setPersonalData("set-lesson", {
        ...getDataFromRedux,
        provide: { renderEquipments, renderApparels, renderAccessories },
        bring: {
          renderEquipmentsForBring,
          renderApparelsForBring,
          renderAccessoriesForBring,
        },
      })
    );
  }

  const convertedActiveTab = activeTab?.includes("-")
    ? activeTab.split("-")[0] + " " + activeTab.split("-")[1]
    : activeTab;

  return (
    <div className={[classes.WhatsincludedScreen].join(" ")}>
      <style jsx>{`
        .${accordionCss.customAccordion} button:focus {
          color: ${Colors.mainBlue} !important;
        }
      `}</style>
      <div className={[classes.mainheading, classes.mb32].join(" ")}>
        <img
          src={cancelIcon}
          className={[classes.crossimg]}
          alt="..."
          onClick={() => history.goBack()}
        />
        <p
          style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
          className={[classes.textcenter].join(" ")}
        >
          Edit Lesson Info
        </p>
      </div>

      <Container className={["p-0", classes.container].join(" ")}>
        <Row className={["g-0", classes.row].join(" ")}>
          <Col md={12}>
            <Col sm={12} className={[classes.mb32].join(" ")}>
              <Tabs
                tabsData={[
                  { label: "Basic info", activeText: "basic-info" },
                  { label: "What’s included", activeText: "whats-included" },
                  { label: "Location", activeText: "location" },
                ]}
                state={{ label: activeTab }}
                setState={(item) => dispatch(setActiveTab(item?.activeText))}
                matchWithActiveText={true}
              />
            </Col>
            <Col md={12} className={classes.mb24}>
              <h4
                style={{
                  ...Fonts.h4,
                  fontSize: "20px",
                  lineHeight: "28px",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                What will you provide?
              </h4>
              <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
                Select the things you can provide for your future students.
              </p>
            </Col>

            <Col md={12}>
              <CommonQuestions
                padding={"24px 0px"}
                data={willProvide?.map((item) => ({
                  title: (
                    <div className={classes.spaceBetween}>
                      <span
                        style={{
                          ...Fonts.b3,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        {item?.title}
                      </span>
                      <span>
                        <LinkButtonWithIcon
                          text={"Add item"}
                          leftIcon={AddIconBlue}
                          primary={true}
                          customStyle={{
                            ...Fonts.b2,
                          }}
                          iconStyle={{
                            marginRight: "4px",
                            width: "16px",
                            height: "16px",
                          }}
                          onClick={() => {
                            setModalTitle(item?.title);
                            setSectionTitle("what will you provide?");
                            setShowEquipmentModal(true);
                          }}
                        />
                      </span>
                    </div>
                  ),
                  description: (
                    <ul className={classes.checkboxList}>
                      {item?.state.map((check, i) => {
                        return (
                          <li>
                            <Checkbox
                              label={check.label}
                              checked={check?.label == check?.isChecked}
                              onClick={(e) => {
                                const newArr = [...item?.state];
                                if (newArr[i].isChecked !== check?.label) {
                                  newArr[i].isChecked = check?.label;
                                } else {
                                  newArr[i].isChecked = "";
                                }
                                item?.setter(newArr);
                              }}
                            />
                          </li>
                        );
                      })}
                    </ul>
                  ),
                }))}
              />
            </Col>
            <Col
              md={12}
              className={`${[classes.mb24, classes.mt56].join(" ")}`}
            >
              <h4
                style={{
                  ...Fonts.h4,
                  fontSize: "20px",
                  lineHeight: "28px",
                  color: Colors.neutralShadesOfNero,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                What student should bring?
              </h4>
              <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
                Select the things that the student should take to your lesson.
              </p>
            </Col>
            <Col md={12}>
              <CommonQuestions
                padding={"24px 0px"}
                data={shouldBring?.map((item) => ({
                  title: (
                    <div className={classes.spaceBetween}>
                      <span
                        style={{
                          ...Fonts.b3,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        {item?.title}
                      </span>
                      <span>
                        <LinkButtonWithIcon
                          text={"Add item"}
                          leftIcon={AddIconBlue}
                          primary={true}
                          customStyle={{
                            ...Fonts.b2,
                            lineHeight: "20px",
                          }}
                          iconStyle={{
                            marginRight: "4px",
                            width: "16px",
                            height: "16px",
                          }}
                          onClick={() => {
                            setModalTitle(item?.title);
                            setSectionTitle("what student should bring?");
                            setShowEquipmentModal(true);
                          }}
                        />
                      </span>
                    </div>
                  ),
                  description: (
                    <ul className={classes.checkboxList}>
                      {item?.state.map((check, i) => {
                        return (
                          <li>
                            <Checkbox
                              label={check.label}
                              checked={check?.label == check?.isChecked}
                              onClick={(e) => {
                                const newArr = [...item?.state];
                                if (newArr[i].isChecked !== check?.label) {
                                  newArr[i].isChecked = check?.label;
                                } else {
                                  newArr[i].isChecked = "";
                                }
                                item?.setter(newArr);
                              }}
                            />
                          </li>
                        );
                      })}
                    </ul>
                  ),
                }))}
              />
            </Col>
          </Col>

          <Col xs={12} style={{ alignSelf: "flex-end" }}>
            <Button
              customStyle={{ width: "100%", height: "56px" }}
              primary={true}
              size="Large"
              onClick={saveDataIntoRedux}
            >
              Save changes
            </Button>
          </Col>
        </Row>
      </Container>
      {/* Add Equipment Modal */}
      <AddEquipmentModal
        show={showEquipmentModal}
        setShow={setShowEquipmentModal}
        title={modalTitle}
        onAdd={onAdd}
        setter={setModalData}
        state={modalData}
        options={["avbc", "cass"]}
      />
    </div>
  );
};
export default WhatsIncludedMobile;
